import { styled } from '@qadra/frontend-common';
import { SPACINGS } from '@qadra/frontend-common-ts';
import { polished } from '@qadra/frontend-common/utils';

export const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 600px;
  box-shadow: 0 0 0 1px ${(p) => p.theme.colors.primary}, 0 0 0 5px ${(p) => p.theme.colors.white},
    0 0 0 6px ${(p) => polished.transparentize(0.2, p.theme.colors.primary)},
    0 0 0 10px ${(p) => p.theme.colors.white},
    0 0 0 11px ${(p) => polished.transparentize(0.4, p.theme.colors.primary)},
    0 0 0 15px ${(p) => p.theme.colors.white},
    0 0 0 16px ${(p) => polished.transparentize(0.6, p.theme.colors.primary)},
    0 0 0 20px ${(p) => p.theme.colors.white},
    0 0 0 21px ${(p) => polished.transparentize(0.8, p.theme.colors.primary)};

  ${(p) => p.theme.mediaQueries.isMobile} {
    width: 100%;
    margin-top: 50px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  margin-top: 100px;
  max-width: 600px;
  width: 100%;
  flex-direction: column;
`;

export const profilingCardStyle = (theme) => ({
  marginBottom: SPACINGS[6],
  boxShadow: theme.boxShadows.base,
  padding: SPACINGS[12],
  width: theme.dimensions.maxCardWidth,
  maxWidth: theme.dimensions.maxCardWidth,
  minHeight: 600,
});
